import { faCopy, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Axios from 'axios';
import moment from 'moment';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useApi } from '~/hooks/useApi';
import useModalManager from '~/hooks/useModalManager';
import { Tooltip } from '../ui';
import { FormAssistent } from './FormAssistent';

const FormListWrapper = styled.div``;

const TableRow = styled.tr`
    border-radius: ${(p) => p.theme.borderRadius};
    box-shadow: ${(p) => (p.selected ? p.theme.shadows.sm : 'none')};
    background-color: ${(p) => (p.selected ? 'rgba(0, 0, 0, 0.05)' : 'transparent')};
    cursor: pointer;

    > * {
        vertical-align: middle !important;
    }

    th:first-child {
        border-top-left-radius: ${(p) => p.theme.borderRadius};
        border-bottom-left-radius: ${(p) => p.theme.borderRadius};
    }

    td:last-child {
        border-bottom-right-radius: ${(p) => p.theme.borderRadius};
        border-top-right-radius: ${(p) => p.theme.borderRadius};
    }
`;

export const FormList = ({ cb, selected, ...props }) => {
    const { addModal } = useModalManager();
    const [forms, setForms] = useState([]);
    const [selectedForm, setSelectedForm] = useState(selected);
    const api = useApi();
    const handleClose = () => setOverlay({ title: '', content: null, show: false });

    useEffect(() => {
        if (typeof selected !== 'object') {
            const form = forms.find((form) => form.id === selected);

            setSelectedForm(form);
            if (cb) cb(form);
        }
    }, [selected, forms]);

    const selectForm = (form) => {
        setSelectedForm(form);
        if (cb) {
            cb(form);
        }
    };

    const addForm = (form) => {
        setForms([...forms, form.data]);
        handleClose();
    };

    const openAddForm = () => {
        addModal({ title: 'Formular hinzufügen', content: <FormAssistent cb={addForm} />, show: true });
    };

    const openEditForm = (form) => {
        addModal({
            title: 'Formular bearbeiten',
            content: <FormAssistent form={form} cb={updateForm} />,
            show: true
        });
    };

    const handleDelete = (form) => {};

    const updateForm = (form) => {
        setForms(forms.map((f) => (f.id === form.id ? form : f)));
        handleClose();
    };

    const duplicateForm = (form) => {
        api({
            url: 'form/' + form.id + '/duplicate',
            method: 'GET',
            onSuccess: (data) => {
                setForms([...forms, data.data]);
                setOverlay({
                    title: 'Formular bearbeiten',
                    content: <FormAssistent form={data.data} cb={updateForm} />,
                    show: true
                });
            }
        });
    };

    useEffect(() => {
        const source = Axios.CancelToken.source();
        api({
            url: 'user/forms',
            method: 'GET',
            cancelToken: source.token,
            onSuccess: (data) => setForms(data.data)
        });
        return () => {
            source.cancel();
        };
    }, []);

    return (
        <FormListWrapper {...props}>
            {forms.length > 0 ? (
                <>
                    <small className="text-muted">Klicke auf den Namen eines Formulars um es auszuwählen</small>
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Felder</th>
                                <th scope="col">Erstellt am</th>
                                <th scope="col">Optionen</th>
                            </tr>
                        </thead>
                        <tbody>
                            {forms.map((form) => (
                                <TableRow
                                    selected={selectedForm?.id === form.id}
                                    key={'form_id_' + form.id}
                                    onClick={() => selectForm(form)}
                                >
                                    <th scope="row">{form.name}</th>
                                    <td>
                                        <Tooltip
                                            trigger={['hover', 'focus']}
                                            placement="top"
                                            overlay={
                                                <ul className="list-unstyled">
                                                    {form.fields.map((f) => (
                                                        <li key={form.id + f.name}>{f.label}</li>
                                                    ))}
                                                </ul>
                                            }
                                        >
                                            <span>{form.fields.length}</span>
                                        </Tooltip>
                                    </td>
                                    <td>{moment(form.created_at).format('DD.MM.YYYY, HH:mm')}</td>
                                    <td>
                                        <div className="btn-group" role="group">
                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => duplicateForm(form)}
                                            >
                                                <FontAwesomeIcon icon={faCopy} />
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-warning btn-sm"
                                                onClick={() => openEditForm(form)}
                                            >
                                                <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                disabled
                                                onClick={() => deleteHandler(form)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </div>
                                    </td>
                                </TableRow>
                            ))}
                        </tbody>
                    </table>
                </>
            ) : (
                <small className="text-muted">Noch keine Formulare erstellt</small>
            )}
            <div className="btn btn-success btn-block btn-sm" onClick={openAddForm}>
                Formular hinzufügen
            </div>
        </FormListWrapper>
    );
};
